import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const STEPS = [
  { n: "01", t: "Tell Us About Your Event", d: "Enter the event date, location, guest count, event type, and rental details." },
  { n: "02", t: "Choose One or Two Trailers", d: "Select the number of three-stall luxury restroom trailers you need." },
  { n: "03", t: "Send Your Request", d: "Submit your event details online — takes about five minutes." },
  { n: "04", t: "We Confirm & Deliver", d: "Our team replies within 24 hours to confirm availability, share a final quote, and coordinate delivery, setup, and pickup." },
];

export default function HowItWorks() {
  return (
    <div>
      <section className="section">
        <div className="mx-auto max-w-4xl">
          <div className="overline">How It Works</div>
          <h1 className="h-display mt-3 text-5xl md:text-6xl leading-[1.05]">Four elegant steps to an elevated event.</h1>
          <p className="mt-6 text-graphite text-lg leading-relaxed">
            Send us your event details and we'll reply within 24 hours to confirm trailer availability and next steps.
          </p>
        </div>
      </section>

      <section className="pb-24 px-6 md:px-10 lg:px-16">
        <div className="mx-auto max-w-4xl space-y-6">
          {STEPS.map((s, i) => (
            <div key={s.n} className="card-soft p-8 md:p-10 flex flex-col md:flex-row gap-6 items-start">
              <div className="h-display text-6xl md:text-7xl text-pebble/60 leading-none">{s.n}</div>
              <div className="flex-1">
                <h3 className="h-display text-2xl md:text-3xl">{s.t}</h3>
                <p className="text-graphite mt-3 leading-relaxed">{s.d}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mx-auto max-w-4xl mt-16 text-center">
          <Link to="/booking" data-testid="how-request-btn" className="btn-primary">Start your request <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
